import { lazy } from 'react';

// project imports

import Loadable from 'ui-component/Loadable';
import FrontLayout from 'layout/FrontLayout';
import RequiredAuth from 'layout/FrontLayout/RequiredAuth';

//import {Login, Signup, Home} from 'front/pages';



// dashboard routing
const Home = Loadable(lazy(() => import('front/pages/Home')));
const Login = Loadable(lazy(() => import('front/pages/Login')));
const MobileLogin = Loadable(lazy(() => import('front/pages/MobileLogin')));
const ForgotPassword = Loadable(lazy(() => import('front/pages/ForgotPassword')));
const Signup = Loadable(lazy(() => import('front/pages/Signup')));
const ErrorPage = Loadable(lazy(() => import('front/pages/ErrorPage')));
const Profile = Loadable(lazy(() => import('front/pages/Profile')));
const ProductListing = Loadable(lazy(() => import('front/pages/ProductListing')));
const ProductListingTransport = Loadable(lazy(() => import('front/pages/ProductListingTransport')));
const ProductDetails = Loadable(lazy(() => import('front/pages/ProductDetails')));
const Cart = Loadable(lazy(() => import('front/pages/Cart')));
const Wishlist = Loadable(lazy(() => import('front/pages/Wishlist')));
const Checkout = Loadable(lazy(() => import('front/pages/Checkout')));
const Orders = Loadable(lazy(() => import('front/pages/Orders')));

const UserSidebar = Loadable(lazy(() => import('layout/FrontLayout/UserSidebar')));
const MyProposals = Loadable(lazy(() => import('front/pages/MyProposals')));
const MyAddress = Loadable(lazy(() => import('front/pages/MyAddress')));
const MyProducts = Loadable(lazy(() => import('front/pages/MyProducts')));
const AddProduct = Loadable(lazy(() => import('front/pages/AddProduct')));
const MyOrders = Loadable(lazy(() => import('front/pages/MyOrders')));
const MyOrderDetails = Loadable(lazy(() => import('front/pages/MyOrderDetails')));
const MyNotification = Loadable(lazy(() => import('front/pages/MyNotification')));
const Verification = Loadable(lazy(() => import('front/pages/Verification')));
const MyProposalList = Loadable(lazy(() => import('front/pages/MyProposalList')));
const BankDetail = Loadable(lazy(() => import('front/pages/BankDetail')));









// ==============================|| MAIN ROUT ING ||============================== //
   
const FrontRoutes = {
  element: <RequiredAuth />,
  children:[
    {
      path: "/cart",
      element: <Cart />,
    },
    {
      path: "/wishlist",
      element: <Wishlist />,
    },
    {
      path: "/checkout",
      element: <Checkout />,
    },
    {
      path: "/orders",
      element: <Orders />,
    },
   
    {
      path: "/user",
      element: <UserSidebar />,
      children: [
        {
          path: "myproposals/:id",
          element: <MyProposals />,
        },
        {
          path: "myproposallist",
          element: <MyProposalList />,
        },
        {
          path: "profile",
          element: <Profile />,
        },
        {
          path: "myaddress",
          element: <MyAddress />,
        },
        {
          path: "myproducts",
          element: <MyProducts />,
        },
        {
          path: "addproduct",
          element: <AddProduct />,
        },
        {
          path: "addproduct/:id",
          element: <AddProduct />,
        },,
        {
          path: "bankdetail",
          element: <BankDetail />,
        },
        {
          path: "bankdetail/:id",
          element: <BankDetail />,
        },
        {
          path: "myorders",
          element: <MyOrders />,
        },
        {
          path: "myorderdetails/:id",
          element: <MyOrderDetails />,
        },
        {
          path: "mynotification",
          element: <MyNotification />,
        },
        
      ]
    }
  ],
  
};

const SecondRoute = {
  element: <FrontLayout />,
  children: [
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/Home',
      element: <Home />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/mobileLogin',
      element: <MobileLogin />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/signup',
      element: <Signup />
    },
    {
      path: '*',
      element: <ErrorPage />
    },
    {
      path: "/products",
      element: <ProductListing />,
    },
    {
      path: "/products/:catId",
      element: <ProductListing />,
    },
    {
      path: "/transportations",
      element: <ProductListingTransport />,
    },
    {
      path: "/transportations/:catId",
      element: <ProductListingTransport />,
    },
  
    {
      path: "/product/:productId",
      element: <ProductDetails />,
    },
    {
      path: "verification/:verifycode",
      element: <Verification />,
    },
  ]
}


export { FrontRoutes, SecondRoute};

